export const nouns = [
'actor', 'gold', 'painting', 'eye',
'advertisement', 'grass', 'parrot',
'afternoon', , 'pencil',
'battery', 'beard',
'rocket', 'jewellery', 	'day',
'kangaroo', 'shampoo','dinner',
'vacant', 'homophone', 'monkey',
'jacket', 'class', 'night', 'sauce', 
'client', 'operation', 'coconuts', 'kite', 
'assassination', 'yankee', 'chief', 'beans', 
 'unit', 'raccoon', 'rack', 'apple', 'bananas', 'dune', 'sauerkraut', 'slope', 'slant', 'flake', 'pot', 'timber',
'towel', 'brush', 'trash', 'zipper', 'sugar', 'color', 'hair'
]

export const prefixes = [
    'a', 'an', 'ab', 'anti', 'auto', 'ben', 'circum', 'co', 'com', 'con', 'contra', 'counter', 'de', 'di', 'dis', 'eu', 'ex', 'ecto', 'hyper', 'hemi',
    'hypo', 'fore', 'intra', 'mono', 'multi', 'non', 'omni', 'over', 'poly', 'post', 'quad', 're', 'semi', 'trans', 'tri', 'ultra', 'li', 'as'
]

export const properNouns = [
'Mary', 'Richard', 'Dick', 'Dolores', 'Sirhan', 'Abe', 'Ann', 'Charlie', 'Jim', 'Molly', 'Osama',
 'Prudence',  'Jerry', 'Mick', 'Paddy', 'Sandy', 'Skip', 'Tom', 'Brandon', 'Donald', 'Junior', 'Senior', 
'Queen', 'Dagon', 'Cranjis','Adolf', 'Abraham', 'Benjamin', 'Cassandra', 'Cassidy', 'Douglass',  'Kassandra', 'Chuck', 'Buck', 'Lucky', 'Willy', 'Willie'
]

export const properNouns2 = [
'Oswald', 'Hinkley', 'Manson', 'Libshitz', 'Null', 'Gaywood', 'Cummings', 'Dikshit', 'Schmuck', 'Dover', 'Sussex', 'Callahan', 'Cockburn', 'Weiner', 'Hyman',
'Twain', 'Janus', 'Shoemaker', 'Dope', 'Feck', 'Hwang', 'Hooker', 'Woodcock', 'McBasketball', 'Bender', 'Lightwater', 'Rock', 'Wankum', 'Dickinson', 'Player', 'Button', 'Butte', 'Trump', 'Black', 'Dickens', 'Crow', 'Bule', 'Hermann', 'Gay', 'Butts', 'Sporn', 'Medick', 'Dickman',
'Suconcock', 'Aycock', 'Blackie', 
]

export const adjectives = [
    'prudent', 'hunky', 'shiny', 'shy', 'wet', 'Yellow', 'delusional', 'dim', 'hysterical', 'colorful', 'drab', 'dull', 'filthy', 'foolish',
    'gifted', 'grumpy', 'homely', 'jolly', 'joyous', 'kind', 'lazy', 'muddy', 'long', 'nervous', 'open', 'plain', 'poor', 'puzzled', 'quaint',
    'strange', 'sleepy', 'stormy', 'fresh', 'vast', 'weary', 'wide-eyed', 'zany', 'thoughtless', 'forgetful', 'dumb', 'mean', 
]

export const verbs = [
    'parsed', 'harassed', 'jotted', 'hunted', 'worked', 'rushed', 'jerked', 'dictated', 'lingered', 'flipped', 'nipped', 'tucked', 'locked', 'read', 
    'touched', 'worried', 'cried', 'sent', 'wrote'
]

export const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

export const websites = ["Yahoo", "Google", "Microsoft", "Verizon", "Charter", "Spectrum", "Facebook", "Instagram", "Twitter"]